import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from './common/api-client.service';
import { FinraUserLicense } from '../models/finra-user-license/finra-user-license.model';
import { FinraSeriesNumber } from '../models/finra-user-license/finra-series-number.model';
import { FinraUserLicenseDetail } from '../models/finra-user-license/finra-user-license-detail.model';

@Injectable({
  providedIn: 'root'
})
export class FinraUserLicenseService {

  constructor(private apiClient: ApiClientService) { }

  getFinraSeriesNumbers(): Observable<FinraSeriesNumber[]> {
    return this.apiClient.get('api/FinraUserLicense/getFinraSeriesNumbers', null, null, true);
  }

  insertFinraUserLicense(finraUserLicense: FinraUserLicense): Observable<number> {
    return this.apiClient.post('api/FinraUserLicense/insertFinraUserLicense', finraUserLicense, null, true);
  }

  updateFinraUserLicense(finraUserLicense: FinraUserLicense): Observable<number> {
    return this.apiClient.post('api/FinraUserLicense/updateFinraUserLicense', finraUserLicense, null, true);
  }

  updateFinraUserLicenseDetail(finraUserLicenseDetail: FinraUserLicenseDetail): Observable<number> {
    return this.apiClient.post('api/FinraUserLicense/updateFinraUserLicenseDetail', finraUserLicenseDetail, null, true);
  }

  insertFinraUserLicenseDetail(finraUserLicenseDetail: FinraUserLicenseDetail): Observable<number> {
    return this.apiClient.post('api/FinraUserLicense/insertFinraUserLicenseDetail', finraUserLicenseDetail, null, true);
  }

  getFinraUserLicenseById(finraUserLicenseId: number, showLoading: boolean = true): Observable<FinraUserLicense> {
    return this.apiClient.get(`api/FinraUserLicense/getFinraUserLicenseById/${finraUserLicenseId}`, null, null, showLoading);
  }

  deleteFinraUserLicense(finraUserLicenseId: number): Observable<number> {
    return this.apiClient.post(`api/FinraUserLicense/deleteFinraUserLicense/${finraUserLicenseId}`,null, null, true);
  }

  deleteFinraUserLicenseDetail(finraUserLicenseDetailId: number): Observable<number> {
    return this.apiClient.post(`api/FinraUserLicense/deleteFinraUserLicenseDetail/${finraUserLicenseDetailId}`, null, null, true);
  }
}
